import { Box } from "@mui/system";
import styles from "./Breadcrumbs.module.css";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Breadcrumbs() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const taskTitle = queryParams.get("taskTitle");
  const pathname = location.pathname.split("/").filter((x: any) => x);
  const search = location.search; // Preserve query parameters
  const originalParams = useSelector((state: any) => state.maps.originalParams);

  // Safe decode wrapper
  const safeDecode = (value: string) => {
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  };

  const formatBreadcrumbName = (name: any) =>
    name
      .replace(/_/g, " ") // replace underscores with spaces
      .replace(/\b\w/g, (char: any) => char.toUpperCase());

  const breadcrumbs = ["", ...pathname];
  const currentPath = breadcrumbs.join("/");

  return (
    <div className={styles.breadcrumbs}>
      <div className={styles.icon}>
        <img className={styles.starfilledIcon} alt="" src="/starfilled8.svg" />
      </div>
      <div className={styles.link1}>
        {breadcrumbs.map((name, index) => {
          const isHome = index === 0;
          const isFirstAfterHome = index === 1;
          let breadcrumbPath = isHome
            ? ""
            : `${breadcrumbs.slice(1, index + 1).join("/")}`;
          let newBreadcrumbs = breadcrumbs.slice(1, index + 1).join("/");
          const isCurrent = breadcrumbPath === currentPath;
          const fullPath = `${breadcrumbPath}${search}`;

          if (newBreadcrumbs === "data_collection/unifier/maps") {
            name = "Maps";
          } else if (newBreadcrumbs === "admin/processes/etl-sequences") {
            name = "ETL-sequences";
          } else if (newBreadcrumbs === "admin/processes/etl-process-list") {
            name = "ETL-process-list";
          } else if (newBreadcrumbs === "admin/datastore_requests/") {
            name = "Datastore Requests";
          } else if (newBreadcrumbs === "admin/processes/etl-process-log") {
            name = "ETL-process-log";
          } else if (
            newBreadcrumbs === "assets/health/page_speed_performance"
          ) {
            name = "Page Speed Performance";
          } else if (
            newBreadcrumbs === "assets/design/templates/create_new_template"
          ) {
            name = "Create new Template";
          } else if (
            newBreadcrumbs === "assets/design/theme/create_new_theme"
          ) {
            name = "Create new Theme";
          } else if (newBreadcrumbs === "assets/design/theme/edit_new_theme") {
            name = "Edit new Theme";
          } else if (
            newBreadcrumbs === "assets/design/templates/edit_new_template"
          ) {
            name = "Edit new Template";
          } else if (newBreadcrumbs === "assets/activity_notes") {
            name = "Activity Notes";
          } else if (newBreadcrumbs === "assets/health/data_accuracy") {
            name = "Data Accuracy";
          } else if (
            newBreadcrumbs === "assets/health/data_accuracy/FTDvsQFTD_NGPD"
          ) {
            name = "FTD vs. QFTD - NGPD";
          } else if (
            newBreadcrumbs === "assets/health/data_accuracy/task_name"
          ) {
            // ✅ Safe decoding applied here
            name = taskTitle ? safeDecode(taskTitle) : "Task Name";
          }

          name = formatBreadcrumbName(name);

          if (isHome && pathname.length === 1) {
            return (
              <Link
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent ? styles.breadcrumbCurrent : styles.breadcrumbLink
                }
                data-tracker="2"
              >
                {(name ? name : "Home").split(" ").join("  ")}
              </Link>
            );
          } else if (isHome) {
            return (
              <Link
                to={breadcrumbPath}
                key={breadcrumbPath}
                className={
                  isCurrent ? styles.breadcrumbCurrent : styles.breadcrumbLink
                }
                data-tracker="2"
              >
                {(name ? name : "Home").split(" ").join("  ")}
              </Link>
            );
          } else if (index === breadcrumbs.length - 1) {
            return (
              <span key={breadcrumbPath} className={styles.breadcrumbCurrent}>
                <Box sx={{ padding: "0 8px" }}>/</Box>
                {
                  //Safe decode applied here
                  safeDecode(name.split(" ").join("  "))
                }
              </span>
            );
          } else if (isFirstAfterHome) {
            return (
              <span
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
              >
                <Box sx={{ padding: "0 8px" }}>/</Box>{" "}
                {name.split(" ").join("  ")}
              </span>
            );
          } else if (newBreadcrumbs === "data_collection/unifier/maps") {
            const mapsPath = originalParams
              ? `${breadcrumbPath}?${originalParams}`
              : breadcrumbPath;
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={mapsPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "admin/datastore_requests") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (index <= 2) {
            if (newBreadcrumbs === "assets/page_management") {
              return (
                <Link
                  style={{ textDecoration: "none" }}
                  to={fullPath}
                  key={breadcrumbPath}
                  className={
                    isCurrent
                      ? styles.breadcrumbCurrent
                      : styles.breadcrumbSeparator
                  }
                  data-tracker="2"
                >
                  <Box
                    sx={{
                      padding: "0 8px",
                      cursor: "default",
                      textDecoration: "none",
                    }}
                  >
                    /
                  </Box>{" "}
                  <Box sx={{ textDecoration: "underline" }}>
                    {name.split(" ").join("  ")}
                  </Box>
                </Link>
              );
            } else if (newBreadcrumbs === "assets/page_builder") {
              return (
                <Link
                  style={{ textDecoration: "none" }}
                  to={fullPath}
                  key={breadcrumbPath}
                  className={
                    isCurrent
                      ? styles.breadcrumbCurrent
                      : styles.breadcrumbSeparator
                  }
                  data-tracker="2"
                >
                  <Box
                    sx={{
                      padding: "0 8px",
                      cursor: "default",
                      textDecoration: "none",
                    }}
                  >
                    /
                  </Box>{" "}
                  <Box sx={{ textDecoration: "underline" }}>
                    {name.split(" ").join("  ")}
                  </Box>
                </Link>
              );
            } else {
              return (
                <span
                  style={{ textDecoration: "none" }}
                  key={breadcrumbPath}
                  className={
                    isCurrent
                      ? styles.breadcrumbCurrent
                      : styles.breadcrumbSeparator
                  }
                >
                  <Box
                    sx={{
                      padding: "0 8px",
                      cursor: "default",
                      textDecoration: "none",
                    }}
                  >
                    /
                  </Box>{" "}
                  {name.split(" ").join("  ")}
                </span>
              );
            }
          } else if (index <= 3) {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box
                  sx={{
                    padding: "0 8px",
                    cursor: "default",
                    textDecoration: "none",
                  }}
                >
                  /
                </Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={styles.breadcrumbSeparator}
                data-tracker="2"
              >
                <Box
                  sx={{
                    padding: "0 8px",
                    cursor: "default",
                    textDecoration: "none",
                  }}
                  data-tracker="2"
                >
                  /
                </Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          }
        })}
      </div>
    </div>
  );
}
